// removed by extract-text-webpack-plugin
module.exports = {"vpUploadError":"vpUploadError___3opAp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/UploadError.module.less
// module id = 3450
// module chunks = 30